/**
 * userService.js — Backend API versiyonu
 * Aile üye yetki/rol/izin/çıkarma işlemleri Firestore yerine PostgreSQL backend'e gider.
 */
import { apiRequest } from "./apiClient";

const aktifFamilyId = (familyId) => {
  if (familyId) return familyId;
  try { return localStorage.getItem("fp:aktivFamilyId") || ""; } catch { return ""; }
};

const requireFamilyId = (familyId) => {
  const id = aktifFamilyId(familyId);
  if (!id) throw new Error("Aktif aile bulunamadı.");
  return id;
};

export const uyeYetkiDegistirService = async ({ uyeId, yeniYetki, familyId }) => {
  const fId = requireFamilyId(familyId);
  await apiRequest(`/families/${fId}/members/${uyeId}`, {
    method: "PATCH",
    body: JSON.stringify({ role: yeniYetki, aileYetkisi: yeniYetki }),
  });
};

export const uyeRolDegistirService = async ({ uyeId, yeniRol, familyId }) => {
  const fId = requireFamilyId(familyId);
  await apiRequest(`/families/${fId}/members/${uyeId}`, {
    method: "PATCH",
    body: JSON.stringify({ rol: yeniRol }),
  });
};

export const uyeyiAiledenCikarService = async ({ uyeUid, familyId }) => {
  const fId = requireFamilyId(familyId);
  await apiRequest(`/families/${fId}/members/${uyeUid}`, {
    method: "DELETE",
  });
};

export const yetkiKaydetService = async ({ uyeId, yeniPermissions, familyId }) => {
  const fId = requireFamilyId(familyId);
  await apiRequest(`/families/${fId}/members/${uyeId}`, {
    method: "PATCH",
    body: JSON.stringify({ permissions: yeniPermissions }),
  });
};
